import { reducer as assignment } from "./assignment/slice";

export const reducer = {
  assignment,
};
